import { bytesToHex64 } from "./nullaCodec.js";

/** Markdown link → preview mounts `<video>` from decoded bytes (WebM from MediaRecorder). */
export const MAX_MAX_VIDEO_HEX_PREFIX = "npp-max-video:1;";

/** Markdown link → preview mounts `<audio>` from decoded bytes (WebM from MediaRecorder). */
export const MAX_MAX_AUDIO_HEX_PREFIX = "npp-max-audio:1;";

/** Raw clip size cap before hex encoding (same order of magnitude as file-insert video cap). */
export const MAX_MAX_HEX_MEDIA_CLIP_BYTES = 40 * 1024 * 1024;

export function buildMaxVideoHexMarkdownLink(displayLabel: string, videoBytes: Uint8Array): string {
  const hex = bytesToHex64(videoBytes);
  const label = displayLabel.replace(/[\[\]\r\n()]/g, " ").trim().slice(0, 120) || "Video";
  return `\n\n[${label}](<${MAX_MAX_VIDEO_HEX_PREFIX}${hex}>)\n\n`;
}

export function buildMaxAudioHexMarkdownLink(displayLabel: string, audioBytes: Uint8Array): string {
  const hex = bytesToHex64(audioBytes);
  const label = displayLabel.replace(/[\[\]\r\n()]/g, " ").trim().slice(0, 120) || "Audio";
  return `\n\n[${label}](<${MAX_MAX_AUDIO_HEX_PREFIX}${hex}>)\n\n`;
}
